var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/util/getDisplayName.js
// module id = 1961
// module chunks = 1